<template>
  <div>
    <h3 class="mb-4">
      {{ title }}
    </h3>
    <el-form
      ref="contactForm"
      :model="contactForm"
      :rules="rules"
      class="contact-form d-flex flex-wrap"
    >
      <div class="contact-form__left w-100 w-md-50">
        <el-form-item
          prop="name"
          class="mb-2"
        >
          <el-input
            v-model="contactForm.name"
            placeholder="Naam*"
            class="business"
          />
        </el-form-item>

        <el-form-item
          class="mb-2"
        >
          <el-input
            v-model="contactForm.city"
            placeholder="Woonplaats"
            class="business"
          />
        </el-form-item>

        <el-form-item
          class="mb-2"
        >
          <el-input
            v-model.trim="contactForm.phone"
            placeholder="Telefoonnummer"
            type="number"
            class="business"
          />
        </el-form-item>

        <el-form-item
          prop="from"
          class="mb-2"
        >
          <el-input
            v-model="contactForm.from"
            placeholder="E-mail*"
            class="business"
          />
        </el-form-item>
      </div>

      <div class="contact-form__right w-100 w-md-50 pl-md-3">
        <el-form-item
          prop="message"
          class="mb-2"
        >
          <el-input
            v-model="contactForm.message"
            type="textarea"
            placeholder="Uw vraag*"
            class="business"
          />
        </el-form-item>

        <div class="d-flex">
          <el-button
            type="business"
            class="ml-auto"
            @click="submitForm('contactForm')"
          >
            Verzenden <i class="ml-3 fa fa-chevron-right"></i>
          </el-button>
        </div>
      </div>
    </el-form>

  </div>
</template>

<script>
import Service from '@/services/ApiService'

export default {
  name: 'ec-business-contact-form',
  props: {
    email: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      contactForm: {
        name: '',
        city: '',
        phone: '',
        from: '',
        message: ''
      },
      rules: {
        from: [
          {
            required: true,
            message: 'E-mailadres is verplicht',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: 'Ongeldig e-mailadres'
          }
        ],
        message: [
          {
            required: true,
            message: 'Vraag is verplicht',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: 'Naam is verplicht',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    sendForm (data) {
      Service.post('community/business/contact', data).then((res) => {
        if (res.status === 'success') {
          this.$message({
            message: res.message,
            type: 'success'
          })
        }
      }, () => {
        this.$message({
          message: 'Oeps, er is iets misgegaan. Probeer het later nog een keer.',
          type: 'error'
        })
      })
    },
    submitForm (formName) {
      let data = JSON.parse(JSON.stringify(this.contactForm))

      data.community_mail = process.env.NODE_ENV === 'development' ? 'tobias@enjoj.nl' : this.email

      data.url = 'https://www.enjoj.nl' + this.$route.fullPath

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sendForm(data)
        } else {
          this.$message({
            message: 'Niet alle velden zijn (correct) ingevuld.',
            type: 'error'
          })
        }
      })
    }
  }
}
</script>
